import React from 'react';
import { devError } from '../lib/constants';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    devError('React error boundary caught:', error, info);
  }
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F4F5] p-6 grid-pattern">
        <div className="max-w-md w-full bg-white border border-zinc-900 shadow-brutal p-8" data-testid="error-boundary">
          <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-red-600 mb-2">SOMETHING BROKE</div>
          <h2 className="font-display text-3xl font-black tracking-tighter mb-3">We hit a snag.</h2>
          <p className="text-sm text-zinc-600 mb-5">
            The page crashed unexpectedly. Your data is safe. Refresh the page to continue — if it happens again, screenshot this and let your admin know.
          </p>
          {this.state.error?.message && (
            <pre className="text-xs font-mono bg-zinc-100 border border-zinc-300 p-3 mb-5 overflow-x-auto">{String(this.state.error.message).slice(0, 200)}</pre>
          )}
          <button
            onClick={() => window.location.reload()}
            data-testid="reload-app"
            className="w-full bg-[#002FA7] text-white py-3 text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#002088]"
          >
            Reload App →
          </button>
        </div>
      </div>
    );
  }
}
